import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import Mision from './Mision';
import Vision from './Vision';
const Principal = () => {
  return (
    <>
    
    <Container style={{gap:"10px" }}>
    <div className='div-mision ' data-aos="flip-right">
    <Row className='row-esp'>
        
        <Mision/>
        <Vision/>
        </Row>
          </div>
    </Container>
</>


  )
}

export default Principal